// extracted by mini-css-extract-plugin
export default {"footer-container":"footer_footer-container__Il2IH","footer-section":"footer_footer-section__VqSmX","footer-icon":"footer_footer-icon__e8qd2"};